import { combineReducers } from 'redux'
import { STATES_TO_RESET_ARR } from 'utils/constants'
import caregiverReducer from './selectedParticipant'
import locationReducer from './location'
import modalReducer from './modal'
import drawerReducer from './drawer'
import userReducer from './user'
import localesReducer from './locales'
import loadingReducer from './loader'
import navBarReducer from './navbar'
import tableFilterReducer from './tableFilters'
import searchTermReducer from './searchTerm'
import stringsReducer from './strings'
import { errorReducer } from '../layouts/ErrorBox'
import consentReducer from '../routes/Consent/modules/Consent'

export const makeRootReducer = asyncReducers => {
  const combinedReducer = combineReducers({
    ...asyncReducers,
    drawer: drawerReducer,
    consent: consentReducer,
    errorBox: errorReducer,
    loading: loadingReducer,
    locales: localesReducer,
    location: locationReducer,
    modal: modalReducer,
    navBar: navBarReducer.navProps,
    searchTerm: searchTermReducer,
    strings: stringsReducer,
    subroute: navBarReducer.subroute,
    tableFilters: tableFilterReducer,
    user: userReducer,
    caregiver: caregiverReducer
  })

  const rootReducer = (state, action) => {
    const newState = { ...state }
    if (action.type === 'USER_LOGGED_OUT') {
      // return initial state for all partiicpant-sensitive reducers
      STATES_TO_RESET_ARR.forEach(stateKey => {
        delete newState[stateKey]
      })
    }

    return combinedReducer(newState, action)
  }

  return rootReducer
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  // Reducer injection intentionally mutates store extension point.
  // eslint-disable-next-line no-param-reassign
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export const injectReducers = (store, reducers) => {
  Object.keys(reducers).forEach(key => {
    injectReducer(store, { key, reducer: reducers[key] })
  })
}

export default makeRootReducer
